import React from "react";
import {BsExclamationCircle} from "react-icons/bs";

const NoDataComponent = () => {
  return (
    <div
      style={{
        height: "20vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <BsExclamationCircle size={36} />
      <h3 style={{marginTop: 10, fontWeight: 400}}>No Data Found!</h3>
    </div>
  );
};

export default NoDataComponent;
